<template>
  <modal
    :shown="modal"
    @close="$emit('reset')"
  >
    <div class="p-5 text-center">
      <div class="px-5">
        <span v-if="user.isActive">{{ $t('user-management.deactivate', { name: user.fullname }) }}</span>
        <span v-else>{{ $t('user-management.activate', { name: user.fullname }) }}</span>
      </div>
      <div class="d-flex justify-content-around mt-5">
        <button
          class="btn btn-sm btn-outline-info py-2"
          @click="$emit('reset')"
        >
          {{ $t('user-management.cancel') }}
        </button>
        <button
          class="btn btn-sm btn-info py-2"
          @click="$emit('update')"
        >
          {{ $t('user-management.update-status') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  components: {
    Modal
  },

  props: {
    modal: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
